import { Card } from '@brg/api'
import { FC, useMemo } from 'react'
import { QueueMode } from '../../QueueNew'
import {
    QueueViewLineContainer
} from '../../styles'
import QueueLineNew from '../QueueLineNew'
import { QueuePoint, QueueRate } from '../QueueLineNew/QueueLineNew'
import { useTariffs } from "../../../helpers/queueHooks";

interface QueueViewProps {
    activeCard?: Card
    currentQueuePoint: QueuePoint
    userQueuePoints: QueuePoint[]
    rate: QueueRate
    isBook?: boolean
}

export const QueueView: FC<QueueViewProps> = ({ activeCard, currentQueuePoint, userQueuePoints, rate, isBook }) => {
    const posMap = useMemo(() => [0, 0.5, 1], [])
    const { changePrice, onChangeTariff, onPay, sequenceInfo } = useTariffs({})


    return <>
        <QueueViewLineContainer width="100%">
            <QueueLineNew
                activeCard={activeCard}
                currentQueuePoint={currentQueuePoint}
                userQueuePoints={userQueuePoints}
                circlePoses={posMap}
                circlePosesMob={posMap}
                rate={rate}
                mode={QueueMode.view}
                isBook={isBook || false}
                sequenceInfo={sequenceInfo}
            />
            {/*блок связанных товаров */}
            {/*подпись количества карточек в книге */}
        </QueueViewLineContainer>
    </>
}
import { Card } from '@brg/api'
import { FC, useMemo } from 'react'
import { QueueMode } from '../../QueueNew'
import {
    QueueViewLineContainer
} from '../../styles'
import QueueLineNew from '../QueueLineNew'
import { QueuePoint, QueueRate } from '../QueueLineNew/QueueLineNew'
import { useTariffs } from "../../../helpers/queueHooks";

interface QueueViewProps {
    activeCard?: Card
    currentQueuePoint: QueuePoint
    userQueuePoints: QueuePoint[]
    rate: QueueRate
    isBook?: boolean
}

export const QueueView: FC<QueueViewProps> = ({ activeCard, currentQueuePoint, userQueuePoints, rate, isBook }) => {
    const posMap = useMemo(() => [0, 0.5, 1], [])
    const { changePrice, onChangeTariff, onPay, sequenceInfo } = useTariffs({})


    return <>
        <QueueViewLineContainer width="100%">
            <QueueLineNew
                activeCard={activeCard}
                currentQueuePoint={currentQueuePoint}
                userQueuePoints={userQueuePoints}
                circlePoses={posMap}
                circlePosesMob={posMap}
                rate={rate}
                mode={QueueMode.view}
                isBook={isBook || false}
                sequenceInfo={sequenceInfo}
            />
            {/*блок связанных товаров */}
            {/*подпись количества карточек в книге */}
        </QueueViewLineContainer>
    </>
}
